import type { UserContextType } from './UserContext'
import { useContext } from 'react'
import { UserContext } from './UserContext'

export function useUserContext(): UserContextType {
  return useContext(UserContext)
}
